import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";
import logoBtn from "../../../assets/images/btn.png";

export const ButtonPrintPernyataanVerifikasi = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPernyataanVerifikasi = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div style={{ marginBottom: "40px" }}>
          <img src={logoBtn} alt="" width="150" />
        </div>
        <div
          style={{
            textAlign: "center",
            padding: "5px 0",
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>SURAT PERNYATAAN VERIFIKASI</div>
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{"YUDHISTIRA DIAN ASMARA KHARMA"}</td>
              </tr>
              <tr>
                <td>Jabatan</td>
                <td>:</td>
                <td>{"BRANCH MANAGER"}</td>
              </tr>
              <tr>
                <td>Alamat Kantor</td>
                <td>:</td>
                <td>{"JL.Margonda No 186, Kemiri muka, kecbeji , Kota Depok"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px", marginBottom: "10px", fontWeight: "bold", textAlign: "center" }}>MENYATAKAN</div>
          <ol style={{ paddingLeft: "15px" }}>
            <li>
              Telah melaksanakan verifikasi dokumen kelompok sasaran KPR Sejahtera / KPR SSB / KPR SSM sebanyak{" "}
              <span
                style={{
                  color: "#d32f2f",
                  fontWeight: "bold",
                  borderBottom: "2px dotted #d32f2f",
                  padding: "0 4px",
                }}
              >
                ................................................
              </span>{" "}
              pemohon.
            </li>

            <li>
              Bahwa verifikasi dilakukan berupa verifikasi administrasi untuk memastikan ketepatan sasaran dan pemenuhan ketentuan <strong>KPR Sejahtera</strong>.
            </li>

            <li>
              Bahwa verifikasi administrasi yang dilakukan meliputi:
              <ol type="a" style={{ paddingLeft: "24px" }}>
                <li>
                  Pemeriksaan kelengkapan dan kesesuaian dokumen persyaratan pemohon yang meliputi:
                  <ol type="1" style={{ paddingLeft: "32px", listStyleType: "decimal" }}>
                    <li>Surat Pemesanan Rumah dari Pengembang;</li>
                    <li>Identitas pemohon KPR Sejahtera / KPR SSB / KPR SSM;</li>
                    <li>Surat keterangan penghasilan yang sah / slip gaji;</li>
                    <li>Fotokopi Nomor Pokok Wajib Pajak (NPWP);</li>
                    <li>Fotokopi Surat Pemberitahuan (SPT) Tahunan Orang Pribadi;</li>
                    <li>Surat Pernyataan pemohon KPR Sejahtera / KPR SSB / KPR SSM;</li>
                  </ol>
                </li>

                <li>Pemeriksaan kesesuaian penghasilan pemohon dengan ketentuan kelompok sasaran sesuai ketentuan peraturan perundang-undangan;</li>

                <li>Pemeriksaan kesesuaian harga Rumah Umum Tapak / Rumah Susun Umum dengan batasan harga jual sesuai ketentuan peraturan perundang-undangan;</li>

                <li>Analisa kemampuan mengangsur pemohon;</li>
              </ol>
            </li>

            <li>
              Pemberian KPR Sejahtera / KPR SSB / KPR SSM dimaksud telah melalui prosedur sebagai berikut:
              <ol type="a" style={{ paddingLeft: "15px" }}>
                <li>Pemeriksaan kelengkapan data administrasi.</li>
                <li>Wawancara terhadap pemohon.</li>
              </ol>
            </li>

            <li>Berdasarkan hal-hal tersebut pada angka 1 sampai dengan angka 4, maka pemohon sebagaimana dimaksud telah memenuhi syarat dan ketentuan sebagai kelompok sasaran KPR Sejahtera / KPR SSB / KPR SSM dan layak untuk diberikan dana FLPP / Subsidi Bunga Kredit (SBUM).</li>

            <li>Seluruh dokumen persyaratan pemohon sebagaimana dimaksud angka 3 butir a, sesuai dengan aslinya dan dapat dibuktikan sewaktu-waktu apabila dibutuhkan.</li>

            <li>Surat Pernyataan Verifikasi sesuai dengan aslinya, dapat dipertanggungjawabkan dan dapat dibuktikan apabila dibutuhkan sewaktu-waktu.</li>
          </ol>
          <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "280px",
              }}
            >
              <div>
                Bogor, ................................, <br />
                PT. BANK TABUNGAN NEGARA (PERSERO) Tbk
              </div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "end",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "280px",
                textAlign: "center",
              }}
            >
              <div>YUDHISTIRA DIAN ASMARA KHARMA</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
